package org.example.loadingkdz.styles

import org.example.loadingkdz.models.Theme
import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.focus
import com.varabyte.kobweb.silk.components.style.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val MainButtonStyle by ComponentStyle {
    base {
        Modifier
            //.width(100.px)
            .transition(CSSTransition(property = "width", duration = 200.ms))
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Theme.Primary.rgb,
            )
            .color(Colors.White)
            .fontFamily("montserrat")
    }
    hover {
        Modifier//.width(120.px)
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Theme.Secondary.rgb
            )
            .transition(CSSTransition(property = "border", duration = 200.ms))
    }
}

val InputStyle by ComponentStyle {
    base {
        Modifier.border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Theme.LightGray.rgb
            )
            .transition(CSSTransition(property = "border", duration = 200.ms))
            .fontFamily("montserrat")
            .fontSize(14.px)
            .height(27.px)

    }
    focus {
        Modifier.border(
            width = 2.px,
            style = LineStyle.Solid,
            color = Theme.Secondary.rgb
        )
    }
    hover {
        Modifier.border(
            width = 2.px,
            style = LineStyle.Solid,
            color = Theme.Primary.rgb
        )
    }
}

val GroupStyle by ComponentStyle {
    base {
        // from 4 separate [Float] components. Alpha and ColorSpace are optional


        Modifier.backgroundColor(Theme.LighterGray.rgb)
                .margin(5.px)
                .padding(5.px)
                .borderRadius(r = 5.px)
    }
}
